import {Component} from '@angular/core';

@Component({
    selector: 'app-tasks-current',
    templateUrl: './tasks-current.component.html',
    styleUrl: './tasks-current.component.scss'
})
export class TasksCurrentComponent {

}
